module.exports = __webpack_public_path__ + "static/media/photoshop.9853544f.svg";